var fcmServerKey = 'AAAAJH4dKEY:APA91bGJH3U0N1AX6r_Lk58tfT_IywFUc609_3kpj0utIK-rDajPA-4Ll0vHROpYr0kEFu7jACUuPHm7y_dLnyeL9uWW8_gJtZozJJWq5WAtW_r2Ud5P1-omaJZcdCjC8AIfeeLpZVgj'
export default fcmServerKey